const RegistryTabNumber = {
  General: 1,
  ProceduralGuarantees: 2,
  ReferralData: 3,
  SignatureProcess: 7,
};
export default RegistryTabNumber;
